import { useRef, useEffect } from "react";
import { X, Play } from "react-feather";
import styles from "./addjournal.module.css";

const VideoThumbnail = ({ videoUrl, file_path, onRemove }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            const handleLoadedData = () => {
                // Pause immediately once first frame loads
                video.currentTime = 0;
                video.pause();
            };
            video.addEventListener("loadeddata", handleLoadedData);
            return () => video.removeEventListener("loadeddata", handleLoadedData);
        }
    }, []);

    return (
        <div className={styles.ImgFile}>
            <video
                ref={videoRef}
                src={videoUrl}
                muted
                playsInline
                preload="metadata"
                className={styles.videoPreview}
            />

            <span className={styles.playIcon}>
                <Play size={18} />
            </span>

            <button type="button" onClick={(e) => onRemove(file_path)}>
                <X />
            </button>
        </div>
    );
};

export default VideoThumbnail;